<template>
    <div class="preparation-delivery-round-slip-page">
        <transition name="loading-screen">
            <LoadingScreen v-if="loading" />
        </transition>
        <template v-if="errors">
            <ErrorsZone :errors="errors" />
        </template>
        <template v-if="loadedOnce && !errors">
            <div class="row mb-2 mt-4">
                <div class="col-md-6 col-12 mx-auto">
                    <h3>Bons de tournée {{ formattedDeliveryDate() }}</h3>
                    <div class="row mb-4">
                        <div class="col-12">
                            <form id="delivery-round-slip-form">
                                <div class="card">
                                    <div class="card-body">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Tournée</th>
                                                    <th>Arrêts</th>
                                                    <th>Imprimer ?</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="deliveryRound in deliveryRounds">
                                                    <td :class="deliveryRound.id === 0 ? 'font-italic text-danger' : ''">
                                                        {{ deliveryRound.name }}
                                                    </td>
                                                    <td>
                                                        {{ deliveryRound.customers.length }}
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" name="deliveryrounds[]" :value="deliveryRound.id" checked>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="alert alert-danger" v-if="hasSlot('deliveryround-error')" >
                                            <i class="fa fa-exclamation-triangle"></i>
                                            <slot name="deliveryround-error"></slot>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-12">
                            <button class="btn btn-info btn-block"
                                    form="delivery-round-slip-form"
                                    formtarget="_blank"
                                    :formaction="`/espace-employes/commandes/livraison/${deliveryDate}/bons-de-tournee/voir`">
                                <i class="fad fa-file-pdf fa-2x"></i>
                                <br>
                                Afficher<br />les bons de tournée
                            </button>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div v-for="printer in printers" class="col-md-6 col-12 mb-2">
                            <button class="btn btn-success btn-block"
                                    form="delivery-round-slip-form"
                                    @click="confirmPrint($event, 'Bons de tournée', printer.name)"
                                    :formaction="`/espace-employes/commandes/livraison/${deliveryDate}/bons-de-tournee/imprimer/${printer.id}`">
                                <i class="fad fa-print fa-2x"></i>
                                <br>
                                Imprimer les bons de tournée
                                <br>
                                {{ printer.name }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone";
    import LoadingScreen from "../LoadingScreen";

    import {useGetLoader} from "../compositions/axios/loadingRequest";
    import {momentDay} from "../../moment-with-helpers";

    export default {
        name: 'DeliveryRoundSlipPage',

        components: {
            ErrorsZone,
            LoadingScreen,
        },

        props: {
            printers: {
                type: Array,
                required: true,
            },
            deliveryRounds: {
                type: Array,
                required: true,
            },
            deliveryDate: {
                type: String,
                required: true,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                loadedOnce: false,
            }
        },

        async mounted() {
            this.loadedOnce = true;
        },

        methods: {
            formattedDeliveryDate() {
                return momentDay(this.deliveryDate).format('dddd Do MMMM YYYY');
            },

            confirmPrint(event, documentName, printerName) {
                let message = 'Êtes vous sûr de vouloir lancer l\'impression du document '+documentName+' sur l\'imprimante '+printerName+' ?';
                if(!confirm(message)) {
                    event.preventDefault();
                }
            },

            hasSlot(name = 'default') {
                return !!this.$slots[name] || !!this.$scopedSlots[name];
            },
        },

    }
</script>

<style lang="scss" scoped>
    .preparation-delivery-round-slip-page {

    }
</style>
